var STATES = {
    TRIAL: 'TRIAL', // Trial, has trialled or had pro before
    BASIC: 'BASIC', // Trial Over
    BASIC_CAN_TRIAL: 'BASIC_CAN_TRIAL', // never trialled
    PREMIUM_MONTHLY: 'PRO_MONTHLY',
    PREMIUM_YEARLY: 'PRO_YAERLY',
    CANCELED: 'CANCELED'
};

function create(subscription, canTrial) {
    if (!subscription && canTrial) {
        return STATES.BASIC_CAN_TRIAL;
    }

    if (!subscription && !canTrial) {
        return STATES.BASIC;
    }

    if (subscription.cancel_at_period_end) {
        return STATES.CANCELED;
    }

    if (subscription.status === 'trialing') {
        return STATES.TRIAL;
    }

    if (subscription.plan.interval === 'month') {
        return STATES.PREMIUM_MONTHLY;
    }
    if (subscription.plan.interval === 'year') {
        return STATES.PREMIUM_YEARLY;
    }

}

module.exports = {
    create: create,
    STATES: STATES
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/subscription.state.factory.js
// module id = 411
// module chunks = 0